import axiosClient from "api/axios_client.js";

const BASE = "/reminder-builder/reminder-setup/recipient-type";

// tbl_rem_recipient_type. Write calls are Super Admin only.
const apiReminderRecipientType = {
  create:       (payload)     => axiosClient.post(`${BASE}/create`, payload),
  update:       (id, payload) => axiosClient.put(`${BASE}/update/${id}`, payload),
  getAll:       (payload)     => axiosClient.post(`${BASE}/get-all`, payload),
  getById:      (id)          => axiosClient.get(`${BASE}/get-by-id/${id}`),
  delete:       (ids)         => axiosClient.delete(`${BASE}/delete`, { data: { ids } }),
  // Recipient types the builder can resolve, with their defaults and recipient_type_fid when set up.
  getResolvers: ()            => axiosClient.get(`${BASE}/get-resolvers`),
};

export default apiReminderRecipientType;
